import { BuildFlavour } from './BuildFlavour'
import Logo from '../../assets/logo-clipsal.svg'
import LogoSmall from '../../assets/logo-clipsal-short.svg'
import { CtasClipsal } from '../text/CtasClipsal'
import { CopyGeneric } from '../text/Copy'
import { CopyClipsal } from '../text/CopyClipsal'

export const ClipsalFlavour: BuildFlavour = {
  builderTitle: 'Clipsal Iconic Builder',
  logo: Logo,
  logoHeight: '26px',
  logoWidth: '115px',
  squareLogoSize: '26px',
  logoSmall: LogoSmall,
  brandName: 'Clipsal',
  productDataApiEndpoint: `${process.env.REACT_APP_CLIPSAL_CATALOGUE_API_BASE_URL ?? 'https://api.clipsal.com/clipsal/api'}/SwitchSocketBuilder/products`,
  ctas: CtasClipsal,
  mailingListAddress: 'https://www.clipsal.com/sign-up',
  tradeMailingListAddress: 'https://www.clipsal.com/sign-up-trade',
  copy: { ...CopyGeneric, ...CopyClipsal },
  ledModuleItemNo: '40MLEDW',
  currencyCode: 'AUD',
  countryCode: 'au',
}